// Aba da Torre de Controle na URL (`?aba=despacho`), PO1-3506. Antes a aba era
// só estado local; sem isso o ícone "Como usar esta tela" não sabe em que aba o
// usuário está. Os ids são os mesmos de MeuPainel/catalogo.js (ABAS).
// Funções puras, sem React.
export const ABA_PADRAO = "custo";
// "cotacao" (PO1-3628) só existe no GoBID; a lista continua igual à do catálogo.
export const ABAS_TORRE = ["custo", "performance", "despacho", "cotacao", "integracao", "auditoria"];

export function abaDaUrl(search) {
  const q = new URLSearchParams(search || "");
  const aba = String(q.get("aba") || "").trim().toLowerCase();
  return ABAS_TORRE.indexOf(aba) !== -1 ? aba : null;
}

// Devolve o `search` com a aba gravada; a aba padrão sai da URL.
export function urlComAba(search, aba) {
  const q = new URLSearchParams(search || "");
  if (!aba || aba === ABA_PADRAO) q.delete("aba");
  else q.set("aba", aba);
  const s = q.toString();
  return s ? `?${s}` : "";
}
